import { render, staticRenderFns } from "./QuillLinkDialog.vue?vue&type=template&id=61da152e&"
import script from "./QuillLinkDialog.vue?vue&type=script&lang=ts&"
export * from "./QuillLinkDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports